import "core-js/modules/es.string.link.js";
export var datePickerPortalTokens = {
  navItemColors: {
    arrow: function arrow(_ref) {
      var color = _ref.color;
      return color.text.black.base;
    },
    hover: function hover(_ref2) {
      var color = _ref2.color;
      return color.text.link.hover;
    },
    hoverBg: function hoverBg(_ref3) {
      var palette = _ref3.palette;
      return palette.transparent;
    },
    monthYear: function monthYear(_ref4) {
      var color = _ref4.color;
      return color.text.black.base;
    },
    monthYearNonInteractive: function monthYearNonInteractive(_ref5) {
      var color = _ref5.color;
      return color.text.black.base;
    }
  },
  dayOfWeekColor: function dayOfWeekColor(_ref6) {
    var color = _ref6.color;
    return color.text.secondary.base;
  },
  itemColors: {
    base: function base(_ref7) {
      var color = _ref7.color;
      return color.text.black.base;
    },
    nonInteractive: function nonInteractive(_ref8) {
      var palette = _ref8.palette;
      return palette.neutralsBlack.rgba20;
    },
    hoverBg: function hoverBg(_ref9) {
      var palette = _ref9.palette;
      return palette.neutralsBlack.rgba5;
    },
    selected: function selected(_ref10) {
      var color = _ref10.color;
      return color.text.black.base;
    },
    selectedBg: function selectedBg(_ref11) {
      var palette = _ref11.palette;
      return palette.newBlue.hex5;
    },
    selectedHoverBg: function selectedHoverBg(_ref12) {
      var palette = _ref12.palette;
      return palette.newBlue.hex10;
    },
    disabled: function disabled(_ref13) {
      var palette = _ref13.palette;
      return palette.neutralsBlack.rgba20;
    },
    disabledBg: function disabledBg(_ref14) {
      var palette = _ref14.palette;
      return palette.transparent;
    }
  },
  hoverItemRadius: "0",
  applyHoverBgStyleForInRangeDates: true,
  rangePickerSeparatorColor: function rangePickerSeparatorColor(_ref15) {
    var palette = _ref15.palette;
    return palette.transparent;
  },
  rangeBackgroundColor: function rangeBackgroundColor(_ref16) {
    var palette = _ref16.palette;
    return palette.newBlue.hex5;
  },
  today: {
    borderWidth: "0",
    baseBg: function baseBg(_ref17) {
      var palette = _ref17.palette;
      return palette.neutralsBlack.rgba10;
    },
    borderColor: function borderColor(_ref18) {
      var palette = _ref18.palette;
      return palette.transparent;
    },
    fontWeight: "bold",
    circleSize: "28px"
  },
  monthYearCell: {
    radius: {
      current: "20px",
      hover: "0",
      selected: "0"
    },
    borderWidth: "0",
    heightCurrent: "60%"
  }
};